var bW = document.documentElement.clientWidth;
var bH = document.documentElement.clientHeight;
function resizeWindow(){
  bW = document.documentElement.clientWidth;
  bH = document.documentElement.clientHeight;
}


// kv ripples
$(document).ready(function() {
  $('.p-kv').ripples({
    resolution: 400,
    dropRadius: 20,
    perturbance: 0.02
  });
});


//course slider
const sliderCourse = new Swiper(".slider-course", {
  navigation: {
    nextEl: ".swiper-button-next--course",
    prevEl: ".swiper-button-prev--course",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  loop: true,
  speed: 1500,
  slidesPerView: 1.25,
  centeredSlides: true,
  breakpoints: {
    600: {
      slidesPerView: 3
    },
    1200: {
      slidesPerView: 5
    }
  }
});


//menu slider
const sliderMenu = new Swiper(".slider-menu", {
  navigation: {
    nextEl: ".swiper-button-next--menu",
    prevEl: ".swiper-button-prev--menu",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  loop: true,
  speed: 1500,
  slidesPerView: 1.25,
  centeredSlides: true,
  breakpoints: {
    600: {
      slidesPerView: 3
    },
    1200: {
      slidesPerView: 5
    }
  }
});

const swiperSlides = document.getElementsByClassName("swiper-slide-voice");
const breakPoint = 910; // ブレークポイントを設定
let swiper;
let swiperBool;
window.addEventListener(
  "load",
  () => {
    if (breakPoint < window.innerWidth) {
      swiperBool = false;
    } else {
      createSwiper();
      swiperBool = true;
    }
  },
  false
);
window.addEventListener(
  "resize",
  () => {
    if (breakPoint < window.innerWidth && swiperBool) {
      swiper.destroy(false, true);
      swiperBool = false;
    } else if (breakPoint >= window.innerWidth && !swiperBool) {
      createSwiper();
      swiperBool = true;
    }
  },
  false
);
const createSwiper = () => {
  swiper = new Swiper(".slider-voice", {
    loop: true,
    speed: 1500,
    slidesPerView: 1,
    centeredSlides: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next--voice",
      prevEl: ".swiper-button-prev--voice",
    },
  });
};


//slide button top position
window.onload = function () {
  const buttonareaCourse = document.querySelector('.swiper-button-area--course');
  const buttonareaMenu = document.querySelector('.swiper-button-area--menu');
  const buttonareaVoice = document.querySelector('.swiper-button-area--voice');
  const imgareaCourse = document.querySelector('.slider-course .swiper-slide');
  const imgareaMenu = document.querySelector('.slider-menu .swiper-slide');
  const imgareaVoice = document.querySelector('.slider-voice .p-voice__thumbnail');
  const imgareaVoiceTitle = document.querySelector('.p-voice__h3');
  const imgareaCourseHeight = imgareaCourse.offsetHeight;
  const imgareaMenuHeight = imgareaMenu.offsetHeight;
  const imgareaVoiceHeight = imgareaVoice.offsetHeight;
  const imgareaVoiceTitleHeight = imgareaVoiceTitle.offsetHeight;
  buttonareaCourse.style.top = imgareaCourseHeight / 2 + 'px';
  buttonareaMenu.style.top = imgareaMenuHeight / 2 + 'px';
  buttonareaVoice.style.bottom = imgareaVoiceHeight / 2 + imgareaVoiceTitleHeight + 'px';

  //matchHeight
  $('.matchHeight-campaign').matchHeight();
  /* if(bW > 909){ */
    $('.matchHeight-voice').matchHeight();
  /* } */
}


//fadein animation
$(function(){
  gsap.utils.toArray('.js-fadein').forEach(target => {
    gsap.fromTo(target, {
      /* y: 50, */
      opacity: 0,
    }, {
      scrollTrigger: {
        trigger: target,
        start: "top 85%",
        end: "top 10%",
        /* scrub:true, */
      },
      /* y: 0, */
      opacity: 1,
      duration: 2.6,
    });
  });

  gsap.utils.toArray('.js-fadein-right').forEach(target => {
    gsap.fromTo(target, {
      x: 50,
      opacity: 0,
    }, {
      scrollTrigger: {
        trigger: target,
        start: "top 85%",
        end: "top 10%",
        /* scrub:true, */
      },
      x: 0,
      opacity: 1,
      duration: 2.6,
    });
  });

  gsap.utils.toArray('.js-fadein-left').forEach(target => {
    gsap.fromTo(target, {
      x: -50,
      opacity: 0,
    }, {
      scrollTrigger: {
        trigger: target,
        start: "top 85%",
        end: "top 10%",
        /* scrub:true, */
      },
      x: 0,
      opacity: 1,
      duration: 2.6,
    });
  });
});



document.getElementById('body').classList.add('js-show');